(() => {
  const animations = new WeakMap();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function finish(details, shouldOpen, animationState) {
    if (animations.get(details) !== animationState) return;

    if (!shouldOpen) details.open = false;

    details.classList.remove('is-opening', 'is-closing');
    details.style.removeProperty('overflow');
    animationState.height.cancel();
    animationState.content?.cancel();
    animations.delete(details);
  }

  function toggle(details, summary) {
    const currentAnimation = animations.get(details);
    const wasClosed = !details.open;
    const currentHeight = details.getBoundingClientRect().height;
    const content = summary.nextElementSibling;
    const currentOpacity = wasClosed ? 0 : Number.parseFloat(getComputedStyle(content).opacity);
    const shouldOpen = currentAnimation ? currentAnimation.state === 'closing' : wasClosed;

    currentAnimation?.height.cancel();
    currentAnimation?.content?.cancel();

    details.open = true;
    details.classList.toggle('is-opening', shouldOpen);
    details.classList.toggle('is-closing', !shouldOpen);
    details.style.overflow = 'hidden';
    summary.setAttribute('aria-expanded', shouldOpen);

    const targetHeight = shouldOpen ? details.offsetHeight : summary.offsetHeight;
    const height = details.animate(
      { height: [`${currentHeight}px`, `${targetHeight}px`] },
      {
        duration: shouldOpen ? 280 : 220,
        easing: 'cubic-bezier(0.33, 1, 0.68, 1)',
      }
    );
    const contentAnimation = content?.animate(
      { opacity: [currentOpacity, shouldOpen ? 1 : 0] },
      {
        duration: shouldOpen ? 220 : 140,
        easing: 'ease-out',
      }
    );
    const animationState = {
      content: contentAnimation,
      height,
      state: shouldOpen ? 'opening' : 'closing',
    };

    animations.set(details, animationState);
    height.finished
      .then(() => finish(details, shouldOpen, animationState))
      .catch(() => {});
  }

  document.addEventListener('click', (event) => {
    const summary = event.target.closest?.('.accordion details > summary');
    if (!summary?.nextElementSibling || event.defaultPrevented || reducedMotion.matches) return;

    const details = summary.parentElement;
    event.preventDefault();
    toggle(details, summary);
  });
})();
